import React from 'react';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import BtnFilled from '../../components/BtnFilled';
import AttachmentPreview from './AttachmentPreview';
import { MEDIA_ACCEPT } from './constants';

const SupportChatComposer = ({
  text,
  setText,
  selectedFile,
  sending,
  canSend,
  fileInputRef,
  openFilePicker,
  handleFilePick,
  removeSelectedFile,
  handleKeyDown,
  send,
}) => (
  <div className="border-t border-gray-200 p-3 flex flex-col gap-2">
    <AttachmentPreview file={selectedFile} onRemove={removeSelectedFile} />
    <div className="flex items-end gap-2">
      <button
        type="button"
        aria-label="Прикрепить файл"
        disabled={sending}
        onClick={openFilePicker}
        className="shrink-0 flex items-center justify-center h-11 w-11 rounded-full border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50">
        <AttachFileOutlinedIcon />
      </button>
      <textarea
        className="w-full border border-gray-300 rounded-xl p-2 min-h-[88px] text-gray-900"
        placeholder={selectedFile ? 'Подпись к вложению (необязательно)…' : 'Введите сообщение…'}
        value={text}
        onChange={(event) => setText(event.target.value)}
        onKeyDown={handleKeyDown}
        disabled={sending}
      />
    </div>
    <input ref={fileInputRef} type="file" accept={MEDIA_ACCEPT} hidden onChange={handleFilePick} />
    <BtnFilled title={sending ? 'Отправка…' : 'Отправить'} btnCb={send} disabled={!canSend} />
  </div>
);

export default SupportChatComposer;
